import { Product } from "../context/SearchContext";

export const sendContextConfirmation = (
  products: Product[],
  origin: string,
) => {
  parent.postMessage(
    {
      action: "context:confirm",
      products,
      origin,
    },
    "*",
  );
};

export const sendContextRequest = () => {
  parent.postMessage(
    {
      action: "context:request",
    },
    "*",
  );
};
